<template>
  <el-dialog v-model="isVisible" title="Spots list" width="30%" @close="close">
    <el-form ref="formObj" v-loading="withLoader" :model="form" :rules="rules">
      <el-form-item label="Name" prop="name">
        <el-input v-model="form.name" autocomplete="off" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="close">Cancel</el-button>
        <el-button type="primary" @click="save">Create Spot List</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'

export default defineComponent({
  name: 'SpotListModal',
  props: {
    modelValue: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(props, context) {
    const isVisible = computed(() => props.modelValue)
    const withLoader = ref(props.loading)
    const formObj = ref()

    const rules = {
      name: [
        {
          required: true,
          message: 'This field is required',
          trigger: 'blur'
        }
      ]
    }

    const form = ref({
      name: ''
    })

    const save = () => {
      formObj.value?.validate((valid: boolean) => {
        if (valid) {
          context.emit('save', form.value.name)
        }
      })
    }

    const close = () => {
      formObj.value?.resetFields()
      context.emit('update:modelValue', false)
    }

    return {
      isVisible,
      form,
      rules,
      save,
      close,
      formObj,
      withLoader
    }
  }
})
</script>
